import { Model } from "survey-core";
import { runCompareValidation } from "modules/Library/CRF/components/Survey/Validation/compareValidation";
import { runWindowValidation } from "modules/Library/CRF/components/Survey/Validation/windowValidation";
import {
    applyDependencyVisibility,
    runDependencyRequireValidation,
    handleDependencyValueChange
} from "modules/Library/CRF/components/Survey/Validation/dependencyUtils";
import {
    runConditionalRangeValidation,
    runMinMaxValidation,
    runValueValidation
} from "modules/Library/CRF/components/Survey/Validation/ConditionalRangeValidation";

export function applyRuntimeSurveyLogic(survey: Model) {

    // -----------------------------------------------------
    // 🔥 APPLY DEPENDENCY SHOW / ENABLE
    // -----------------------------------------------------
    applyDependencyVisibility(survey);

    survey.onValueChanged.add((sender, change) => {
        handleDependencyValueChange(sender, change.name);
    });

    // -----------------------------------------------------
    // 🔥 VALIDATION PIPELINE
    // -----------------------------------------------------
    survey.onValidateQuestion.add((sender, options) => {
        const q = options.question;
        if (!q) return;

        // 1️⃣ Dependency Required Validation
        const depError = runDependencyRequireValidation(
            sender,
            options.question,
            options.value
        );

        if (depError) {
            options.error = depError;
            return;
        }

        // 2️⃣ Compare Validation
        if (!runCompareValidation(sender, q, options)) return;

        // 3️⃣ Window Validation
        if (!runWindowValidation(sender, q, options)) return;

        // 4️⃣ Conditional Range + Row Range
        if (!runConditionalRangeValidation(sender, q, options)) return;

        // 5️⃣ Extra Value Validation
        if (!runValueValidation(sender, q, options)) return;
        if (!runMinMaxValidation(sender, q, options)) return;
    });
}
